import { render } from "./u.vue?vue&type=template&id=f6536368"
import script from "./u.vue?vue&type=script&lang=js"
export * from "./u.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/royahayefarda-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__